import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RoomBookingData } from '../../Redux/action/roomAction';
import { dataUser, dataLocation } from '../Helpers/util';
import moment from 'moment';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance';
import AntDDropdown from '../Common/AntDDropdown/AntDDropdown';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import { icons } from 'antd/es/image/PreviewGroup';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
var exportData = [];

class RoomShort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      dropdown: false,
      sort: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      loadingExport: (
        <li >
          <i className="bi bi-upload" /> Loading Export Room Booking
        </li>
      ),
    };
    this.handelDropdown = this.handelDropdown.bind(this);
    this.refreshPage = this.refreshPage.bind(this); 
  }

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  componentDidMount() {
    this.getTotalCount();
  }

  getTotalCount() {
    this.getAllExportData(this.props.total);
  }

 getAllExportData= async (totalCount) => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    const payload = {
          // clientId:newCompanyId.organizationId,
      pgno: 1,
      row: JSON.stringify(totalCount),
      propertyId: this.props.propertyId, 
      clientId:newCompanyId.organizationId,
      type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],

    };
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}meeting-room/api/booking/list`,
       payload
     
      
      );

      if (response.status === 200) {
        const exportData = response.data.data.list.map((item) => ({
          'Room Name': item.resourceName,
          'Room Category': item.resourceCategory ? 'Shared' : 'Private',
          'Room Type': this.getRoomType(item.resourceType),
          Location: item.propertyDetails?.name || '-',
          'User Name': item.hostDetails?.fname || '-',
          'Email': item.hostDetails?.email || '-',
          'Phone Number': item.hostDetails?.phone || '-',
          'Meeting Date': item.bookingDate
            ? moment(item.bookingDate).format('DD MMM YYYY')
            : '-',
          'Start Time': item.start
            ? new Date(item.start).toISOString().split('T')[1].split('.')[0]
            : '-',
          'End Time': item.end
            ? new Date(item.end).toISOString().split('T')[1].split('.')[0]
            : '-',
          Amount: item.pricePerSlot || '0',
          Status: this.getStatus(item.status),
        }));

        const headers = [
          { label: 'Room Name', key: 'Room Name' },
          { label: 'Room Category', key: 'Room Category' },
          { label: 'Room Type', key: 'Room Type' },
          { label: 'Location', key: 'Location' },
          { label: 'User Name', key: 'User Name' },
          { label: 'Email', key: 'Email' },
          { label: 'Phone Number', key: 'Phone Number' },
          { label: 'Meeting Date', key: 'Meeting Date' },
          { label: 'Start Time', key: 'Start Time' },
          { label: 'End Time', key: 'End Time' },
          { label: 'Amount', key: 'Amount' },
          { label: 'Status', key: 'Status' },
        ];

      
   this.setState({
    loadingExport: (
        <CSVLink
          data={exportData}
          headers={headers}
          filename={'Room Booking.csv'}
        >
          <i className="bi bi-upload" /> Export Room Booking
        </CSVLink>
    ),
  });

        // toast.success('Export data prepared successfully!');
      } else {
        throw new Error(response.data.message || 'Failed to fetch export data');
      }
    } catch (error) {
      // toast.error(error.message || 'Something went wrong during export!');
    }
  };

  // Helper to Get Room Type
  getRoomType = (type) => {
    switch (type) {
      case 'Meeting Room':
        return 'Meeting Room';
      case 'Conference Room':
        return 'Conference Room';
      case 'Training Room':
        return 'Training Room';
      case 'AV Lounge':
        return 'Lounge Room';
      default:
        return '-';
    }
  };

  // Helper to Get Status
   getStatus = (status) => {
    if (status == 1) {
      return 'Booked';
    } else if (status == 2) {
      return 'Ended';
    } else if (status == 3) {
      return 'Shared';
    } else if (status == 4) {
      return 'Cancelled';
    } else {
      return 'Unused Booking';
    }
  };






setSelectsort = (key) => {
  const newCompanyId = JSON.parse(localStorage.getItem('headData'));

  const params = {
    clientId: newCompanyId.organizationId,
    propertyId: this.props.propertyId,
    pgno: this.props.pageName,
    row: this.props.row,
    type: [
      "Meeting Room",
      "Conference Room",
      "Training Room",
      "AV Lounge"
    ],
    sortBy: key,
    orderBy: 'desc'
  };

  this.props.RoomBookingData(params);
  this.props.changeshort(params);
};



  refreshPage = e => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    const params = {
      clientId:newCompanyId.organizationId,
      propertyId: this.props.propertyId, 
      pgno: 1, 
      row: 25,

        type: [
          "Meeting Room",
          "Conference Room",
          "Training Room",
          "AV Lounge"
      ],
  
     
    };
    this.props.RoomBookingData(params);
  
  };
  componentWillReceiveProps(props) {
    if (
      props.roomReducer.RoomtList &&
      props.roomReducer.RoomtList.status == 200
    ) {
      this.setState({
        RoomData:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data,

        RoomList:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data &&
          props.roomReducer.RoomtList.data.data.list,
      });
    }
  }

  render() {
   
    const roomReducer = this.props.roomReducer;
    const RoomBooking = this.state.userRole.find(
      element => element.service_id == '16',
    );

    const Loader = this.props.roomLoader.loader;

    // let letLoader = this.state.RoomList;
    // let alldata = letLoader && letLoader !== undefined ? letLoader : [];

    let letLoader = this.props.roomReducer;
    let alldata =
      letLoader &&
        letLoader.RoomtList &&
        letLoader.RoomtList.data &&
        letLoader.RoomtList.data.data &&
        letLoader.RoomtList.data.data.list !== undefined
        ? letLoader.RoomtList.data.data.list
        : [];


    return (
      <>
<li className="ToHideMobile">
  <AntDDropdown
    trigger={['click']}
    placement="bottomRight"
    menu={{
      onClick: ({ key }) => {
        if (
          [
            'resourceName',
            'resourceType',
            'bookingDate',
            'pricePerSlot',
          ].includes(key)
        ) {
          this.setSelectsort(key);
        }

        if (key === 'refresh') {
          this.refreshPage();
        }
      },
      items: [
        {
          key: 'sort',
          label: 'Sort by',
          icon: <i className="bi bi-sort-down-alt"></i>,
          children: [
            {
              key: 'resourceName',
              label: 'Room Name',
              className: 'SortingMenu',
            },
            {
              key: 'resourceType',
              label: 'Room Type',
              className: 'SortingMenu',
            },
            {
              key: 'bookingDate',
              label: 'Booking Date & Time',
              className: 'SortingMenu',
            },
            {
              key: 'pricePerSlot',
              label: 'Amount',
              className: 'SortingMenu',
            },
          ],
        },


        {
          key: 'export',
          label: this.state.loadingExport,
        },

        {
          key: 'refresh',
          label: 'Refresh List',
          icon: <i className="bi bi-arrow-clockwise"></i>,
        },
      ],
    }}
  >
     <SwIconButton size="sm">
                                <i className="bi bi-list" />
                              </SwIconButton>
  </AntDDropdown>
</li>
      </>
    );
  }
}

const mapStateToProps = state => ({
  roomReducer: state.roomReducer,
  roomLoader: state.roomReducer,
});

const mapActionsToProps = {
  RoomBookingData,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomShort);